import React, { useState } from "react";
import TableCstm from "../../../../TableCstm/TableCstm";
import "./CashAuditPreview.scss";
import Button from "../../../../button/button";
import PrintSVG from "../../../../icons/print";
import Tooltip from "../../../../Tooltip/Tooltip";
import { GetPaymentReceiptByIDToReprint } from "../../../../../utils/Apis/receptionApis";
import PaymentReceiptPDF from "../../PaymentReceipt/PaymentReceiptPDF";
import PaymentHistoryLegends from "../../../../paymentHisotryLegends/PaymentHistoryLegends";

const CashAuditPreview = ({ receipts, showAlert, auditedRefundedReceipts }) => {
  const [loading, setLoading] = useState(false)
  if (!receipts || receipts.length === 0) {
    return (
      <div className="cash-audit-preview">
        <h1 className="title-2">Recibos incluidos</h1>
        <p className="empty-msg">No hay recibos en este corte.</p>
      </div>
    );
  }

  const columns = [
    { header: "Acciones", accessor: "act", className: "td tableCtype1" },
    { header: "Fecha", accessor: "date", className: "td tableCtype3" },
    { header: "ID Recibo", accessor: "id", className: "td tableCtype2" },
    { header: "Método", accessor: "payment_method", className: "td tableCtype4" },
    { header: "Monto", accessor: "amount", className: "td amount-col tableCtype2" },
    { header: "Reembolsado", accessor: "refunded_amount", className: "td amount-col tableCtype2" },
  ];


  const handlePrintReceipt = async (receiptId) => {
    setLoading(true)
    const responseReceiptToReprint = await GetPaymentReceiptByIDToReprint(receiptId)
    if (responseReceiptToReprint.status === 200) {
      await handlePrint(responseReceiptToReprint.result)
      setLoading(false)
    } else {
      showAlert(responseReceiptToReprint.message, 'danger')
    }
    setTimeout(() => {
      setLoading(false)
    }, 1500);
  }

  const handlePrint = async (receiptData) => {
    const pdfDoc = await PaymentReceiptPDF(receiptData); // Generate the PDF
    pdfDoc.autoPrint();
    window.open(pdfDoc.output('bloburl'), '_blank');
  };
  const data = receipts.map((r) => ({
    act: (
      <Tooltip text={'Imprimir recibo'} position="right">
        <Button disabled={loading} onClick={() => handlePrintReceipt(r.idRePrint)} Icon={PrintSVG} backgroundColor="transparent" className='print-button' />
      </Tooltip>
    ),
    date: r.date_time,
    id: r.id,
    payment_method: Array.isArray(r.payment_method)
      ? r.payment_method.join(" / ")
      : r.payment_method,
    amount: r.amount,
    refunded_amount: `$${r.refunded_amount}`,
    st_receipt: r.st || '',
    st_refund_status_receipt: r.refund_status || '',
  }));
  const auditedRefundedData = auditedRefundedReceipts.map((r) => ({
    act: (
      <Tooltip text={'Imprimir recibo'} position="right">
        <Button disabled={loading} onClick={() => handlePrintReceipt(r.idRePrint)} Icon={PrintSVG} backgroundColor="transparent" className='print-button' />
      </Tooltip>
    ),
    date: r.date_time,
    id: r.id,
    payment_method: Array.isArray(r.payment_method)
      ? r.payment_method.join(" / ")
      : r.payment_method,
    amount: r.amount,
    refunded_amount: `$${r.refunded_amount}`,
    st_receipt: r.st || '',
    st_refund_status_receipt: r.refund_status || '',
  }));
  const handleRowStatus = (fila) => {
    const statusReceipt = fila.st_receipt || '';
    const status_refund_receipt = fila.st_refund_status_receipt || ''
    if (statusReceipt === "CANCELLED") {
      switch (status_refund_receipt) {
        case 'NONE':
          return 'payment-history-cancelled-receipt'

        case 'PENDING':

          break;
        case 'PARTIAL REFUNDED':
          return 'payment-history-partial-refunded-receipt'

        case 'REFUNDED':
          return 'payment-history-refunded-receipt'

        default:
          return ''
          break;
      }

    }
    if (statusReceipt === "PAID") {
      switch (status_refund_receipt) {
        case 'PENDING':

          break;
        case 'PARTIAL REFUNDED':
          return 'payment-history-partial-refunded-receipt'
        case 'REFUNDED':
          return 'payment-history-refunded-receipt'

        default:
          return ''
          break;
      }

    }
    //NONE', 'PENDING', 'PARTIAL REFUNDED', 'REFUNDED
  };

  return (
    <div className="cash-audit-preview scroll">
      <PaymentHistoryLegends/>
      <h1 className="title-2">Recibos incluidos</h1>
      <TableCstm
        columns={columns}
        data={data}
        className={"cash-audit-table"}
        getRowClass={handleRowStatus}
      />
      <h1 className="title-2">Recibos Rembosaldos de otro corte</h1>
      <TableCstm
        columns={columns}
        data={auditedRefundedData}
        className={"cash-audit-table"}
        getRowClass={handleRowStatus}
      />
    </div>
  );
};

export default CashAuditPreview;
